import store from '#/store';

export default function addProjectRequiredRuleToRouter(router) {
  router.beforeEach((to, from, next) => {
    // this rule only applies if the route record contains the "requiresProject" flag
    const projectIsRequired = to.matched.some((record) => record.meta.requiresProject);
    if (!projectIsRequired) {
      // if project isn't required, bail from this rule immediately after calling next()
      next();
      return;
    }

    // if we made it this far we need a project id in the route.
    if (to.query.project) {
      console.info('router found project in url');
      // TODO: remove workspace param if it exists? - do not allow both workspace and project in route
      // Check if project id in query is present in existing project list
      if (!store.getters.projectById(to.query.project)) {
        console.warn('router project does not match loaded projects');
        // TODO: likely move this set of error inside of the setRouteProjectId itself.
        store.commit('setErrorOnLoad', 'Project Not Found'); // Throw error if project id is absent from store, error set in loadError variable of store
        next();
        return;
      }
      // we've confirmed we have a matching project between route and store. commit.
      store.dispatch('setRouteProjectId', to.query.project).finally(() => {
        next(); // WE MUST CALL next()
      });
      return;
    }

    // check if we have an active project in the store.
    const { activeProjectId } = store.getters;
    if (activeProjectId) {
      const { query } = to;
      query.project = activeProjectId;
      next({ path: to.path, query });
      return;
    }

    // check if we have a history of "last active" project.
    const { lastActiveProjectId } = store.getters;
    if (lastActiveProjectId) {
      const { query } = to;
      query.project = lastActiveProjectId;
      next({ path: to.path, query });
      return;
    }

    // if we still dont have a project id we need to force show the selection modal window so the user can pick
    router.app.$bvModal.show('workspace-project-modal');
    next();
  });
}
